<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Break-Text-Root',
};
</script>
